import { inject } from '@angular/core';

import { NbDialogRef } from '@nebular/theme';

import { EDialogAnswer, TDialogAnswerPayload } from './dialog.types';

export const dialogCloseRef = <T = unknown>() => {
  const dialogRef = inject(NbDialogRef<T>, { optional: true, skipSelf: true });

  return {
    close: <TT = unknown>(answer?: TDialogAnswerPayload<TT>) => dialogRef && dialogRef.close(answer),
    answerType: EDialogAnswer,
  };
};
